<template>
  <div :class="['main', {'main--no-spacing': withoutSpacing}]">
    <div
      class="page-header"
      :class="title || hasHeaderSlot ? '' : 'extra-margin'"
      v-bind="$attrs"
      data-test="invoice_heading"
      v-if="!withoutSpacing"
    >
      <Breadcrumbs v-if="!withoutBreadcrumbs" />

      <div v-if="hasHeaderSlot">
        <slot name="header" />
      </div>

      <div v-else>
        <div
          class="header"
          v-if="$slots['header-right'] || $slots['header-center']"
        >
          <h1
            class="h1"
            v-if="title"
          >
            {{ title }}
          </h1>
          <div class="header-col-center">
            <slot name="header-center" />
          </div>
          <div class="header-col-right">
            <slot name="header-right" />
          </div>
        </div>

        <div
          class="my-24"
          v-else
        >
          <h1
            class="my-0"
            v-if="title"
          >
            {{ title }}
          </h1>
        </div>
      </div>
    </div>

    <div
      :class="{
        'white-container--with-padding': !noWhiteContainer,
        'full-width-on-mobile': fullWidthOnMobile,
        'main__content--no-spacing': withoutSpacing,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContainerWrapper',
  components: {
    Breadcrumbs: () => import('~/components/Common/Breadcrumbs.vue'),
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    noWhiteContainer: {
      type: Boolean,
    },
    fullWidthOnMobile: {
      type: Boolean,
    },
    withoutBreadcrumbs: {
      type: Boolean,
      default: false,
    },
    withoutSpacing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasShiftedFlashMessage() {
      return !this.hasHeaderSlot && !this.title;
    },
    bodyClass() {
      return this.withoutSpacing ? ['shifted-flash-message', 'shifted-flash-message--no-spacing'] : ['shifted-flash-message'];
    },
  },
  mounted() {
    if (this.hasShiftedFlashMessage) {
      document.body.classList.add(...this.bodyClass);
    }
  },
  beforeDestroy() {
    if (this.hasShiftedFlashMessage) {
      document.body.classList.remove(...this.bodyClass);
    }
  },
};
</script>

<style lang="scss" scoped>
.extra-margin {
  margin-top: 16px;
}

.header {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  margin-top: 30px;

  h1 {
    margin: 0;
  }
}

.header-col-center {
  @include media('>md') {
    text-align: center;
  }
}

.header-col-right {
  margin-top: 0;
  text-align: right;
}
</style>

<style lang="scss">
.full-width-on-mobile {
  @media only screen and (max-width: $--breakpoint-sm - 1) {
    margin-left: math.div(-$gutter-width, 2);
    margin-right: math.div(-$gutter-width, 2);
  }
}

.negative-margin {
  @media only screen and (min-width: $--breakpoint-sm) {
    margin-left: rem(-25px);
    margin-right: rem(-25px);
  }
}

.negative-margin--mobile {
  margin-left: rem(-15px);
  margin-right: rem(-15px);

  @media only screen and (min-width: $--breakpoint-sm) {
    margin-left: rem(-25px);
    margin-right: rem(-25px);
  }
}
</style>
